import React from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import "./Calendar.css";

const CalendarButton = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <button
      className="calendar-button btn btn-outline-light"
      onClick={() => navigate("/calendar")}
    >
      📅 {t("navbar.calendar")}
    </button>
  );
};

export default CalendarButton;
